import { render, staticRenderFns } from "./dynamics.vue?vue&type=template&id=677ddd62&scoped=true"
import script from "./dynamics.vue?vue&type=script&lang=js"
export * from "./dynamics.vue?vue&type=script&lang=js"
import style0 from "./dynamics.vue?vue&type=style&index=0&id=677ddd62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ddd62",
  null
  
)

export default component.exports